import React from "react";
import { IoIosArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";
import "../styles/Portfolio.css";
import { projects } from "../assets/portfolioData";
import { IProject } from "../models";

function HomeButton() {
  return (
    <Link id="closePortfolio" to="/" title="Home">
      <IoIosArrowBack style={{ fontSize: "24px" }} />
      <span>Home</span>
    </Link>
  );
}

interface IProjectListProps {
  projects: IProject[];
}

const ProjectList: React.FC<IProjectListProps> = ({ projects }) => {
  return (
    <div className="project-list">
      {projects
        .filter((project) => project.show)
        .map((project, index) => (
          <a
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className="project-item"
            key={index}
          >
            <div className="project-thumbnail">
              <img alt={project.name} src={"images/" + project.img} />
            </div>
            <div className="project-content">
              <div className="project-header">
                <h3 className="project-title">
                  {project.name}
                  <span className="arrow-icon">↗</span>
                </h3>
              </div>
              <p className="project-description">{project.description[0]}</p>
              <div className="project-tags">
                {project.tech.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </a>
        ))}
    </div>
  );
};

export function Portfolio() {
  return (
    <div className="Portfolio">
      <HomeButton />

      <div className="portfolio-container">
        <ProjectList projects={projects} />
      </div>
    </div>
  );
}
